import { connect } from 'react-redux';
import DashboardDetailPartnership from '../components/DashboardDetailPartnership';
import { schema } from '../../../../../state/schema';
import { denormalize } from 'normalizr';
import { loadDashboardSections } from '../../../../../state/modules/dashboardSections/actions';
import { checkOnboardingAnswer } from '../../../../../state/modules/cognitoFormAnswers/actions';

const mapStateToProps = (state, ownProps) => {
  const profileId = state.session.get('profileId');

  const careGuide = ownProps.careGuideId
    ? denormalize(
        state.entities.getIn(['careGuides', ownProps.careGuideId]),
        schema.careGuide,
        state.entities.toJS()
      )
    : null;

  const partnershipId = ownProps.partnershipId;
  const page = 1;
  const limit = 10;
  const order = 'order.asc';

  const result = state.dashboardSections.getIn([
    'pages',
    partnershipId,
    order,
    limit,
    page,
  ]);

  const list = result
    ? result
        .map((x) => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['dashboardSections', x]),
              schema.dashboardSection,
              state.entities.toJS()
            ),
          };
        })
        .toArray()
    : [];

  return {
    list,
    page,
    limit,
    order,
    partnershipId,
    careGuide,
    profileId,
    isLoading: state.dashboardSections.get('isLoading'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (partnershipId, page, limit, order, cb) => {
      dispatch(loadDashboardSections(partnershipId, page, limit, order, cb));
    },
    checkOnboardingAnswer: (partnershipId, careGuideId, cb) => {
      dispatch(checkOnboardingAnswer(partnershipId, careGuideId, cb));
    },
  };
};

const DashboardDetailPartnershipContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardDetailPartnership);

export default DashboardDetailPartnershipContainer;
